import React, { useEffect, useState } from 'react';
import { Table, Container, Spinner, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { logout } from '../redux/reducers/user-actions';
import { useDispatch } from 'react-redux';
import 'bootstrap-icons/font/bootstrap-icons.css';


function OrderList() {
  const [orders, setOrders] = useState([]);
  const [ loading, setLoading] = useState(true);
  const [expandedOrders, setExpandedOrders] = useState(new Set());
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const fetchOrders = async () => {
      const authToken = localStorage.getItem('authToken'); // Assuming the authToken is stored in localStorage
      const response = await fetch(process.env.REACT_APP_API_URL + '/api/order/getlist', {
        headers: {
          'Authorization': `${authToken}`
        }
      });
       if(response.status === 401){
          alert("請重新登入");
          dispatch(logout());
          navigate('/login');
          return
        }
      if (!response.ok) {
        alert("無法取得訂單紀錄，請稍後再試");
        setLoading(false);
        return
      }
      const data = await response.json();
      setOrders(data.list || []);
      setLoading(false);
    };

    fetchOrders();
  }, []);
  const truncateWords = (str, numWords) => {
    if (!str) return '';
    const words = str.split(' ');
    if (words.length > numWords) {
      return words.slice(0, numWords).join(' ') + '...';
    }
    return str;
  };

  const toggleExpand = (orderId) => {
    setExpandedOrders(prev => {
      const s = new Set(prev);
      if (s.has(orderId)) { s.delete(orderId); } else { s.add(orderId); }
      return s;
    });
  };

  const statusText = (status) => {
    switch (status) {
      case "1": return "尚未付款";
      case "2": return "已付款";
      case "3": return "已出貨";
      case "4": return "已完成";
      case "5": return "已取消";
      default: return status;
    }
  };

  if (loading) {
    return (
      <Container className="my-3" style={{ textAlign: 'center', minHeight: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Spinner animation="border" role="status">
          {/* <span className="sr-only">Loading...</span> */}
        </Spinner>
      </Container>
    );
  }

  return (
    <Container className="my-3" style={{ textAlign: 'center', minHeight: '60vh' }}>
      <h1>訂單紀錄</h1>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th style={{ width: '40px' }}></th>
            <th>訂單編號</th>
            <th>時間</th>
            <th>帳號</th>
            <th>歌曲數</th>
            <th>總金額</th>
            <th>訂單狀態</th>
          </tr>
        </thead>
        <tbody>
          {orders.length === 0 ? (
            <tr><td colSpan="7" className="text-center">目前沒有訂單</td></tr>
          ) : orders.map(order => {
            const isExpanded = expandedOrders.has(order.order_id);
            const items = order.items || [];
            return (
            <React.Fragment key={order.order_id}>
            <tr onClick={() => toggleExpand(order.order_id)} style={{ cursor: 'pointer' }}>
              <td className="text-center">
                <Button
                  variant="link"
                  size="sm"
                  className="p-0 text-secondary"
                  aria-expanded={isExpanded}
                  aria-controls={`order-detail-${order.order_id}`}
                  aria-label={isExpanded ? '收合訂單明細' : '展開訂單明細'}
                  onClick={(e) => { e.stopPropagation(); toggleExpand(order.order_id); }}
                >
                  <i className={`bi ${isExpanded ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                </Button>
              </td>
              <td>{"TW" + order.order_id.toString().padStart(6, '0')}</td>
              <td>{order.time}</td>
              <td>{order.costumer_name}</td>
              <td>{items.length}</td>
              <td>{order.total_price}</td>
              <td>{statusText(order.status)}</td>
            </tr>
            {isExpanded && (
              <tr id={`order-detail-${order.order_id}`}>
                <td colSpan="7" style={{ padding: '0.5rem 0.5rem 0.5rem 2.5rem', backgroundColor: '#fafafa', borderLeft: '3px solid #e4e4e7', boxShadow: 'inset 0 1px 0 #e4e4e7' }}>
                  {items.length === 0 ? (
                    <div style={{ textAlign: 'left', color: '#71717a' }}>無商品</div>
                  ) : (
                  <Table borderless size="sm" className="mb-0" style={{ backgroundColor: 'transparent' }}>
                    <thead>
                      <tr>
                        <th style={{ width: '40px' }}></th>
                        <th style={{ color: '#71717a', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.03em', textAlign: 'left' }}>歌曲名稱</th>
                        <th style={{ color: '#71717a', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.03em', textAlign: 'left' }}>數量</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, index) => (
                        <tr key={index}>
                          <td></td>
                          <td style={{ textAlign: 'left' }}>
                            <Link to={`/product/${item}`}>
                              {truncateWords(order.items_name ? order.items_name[index] : '', 50)}
                            </Link>
                          </td>
                          <td style={{ textAlign: 'left' }}>{order.amount ? order.amount[index] : ''}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  )}
                </td>
              </tr>
            )}
            </React.Fragment>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
}

export default OrderList;